import { useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import PredictionTypeTableService from '../service/PredictionTypeTableService';

const config = data => ({
	key: 'predictionTypeTable',
	text: 'Prediction Type',
	textKey: 'predictionType',
	service: PredictionTypeTableService,
	editFormState: item => `/prediction-type/edit/${item ? item.id : 'new'}`,
	toolbarAction: data.user.isSuperAdmin ? ['filter', 'search', 'refresh', 'new'] : ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	filterFields: [
		{
			propertyName: 'project',
			text: 'Project',
			propertyType: 'Long',
			type: 'IN',
			visibleIf: () => data.user.isSuperAdmin
		},
		{
			propertyName: 'sourceDeviceType',
			text: 'Source Device Type',
			propertyType: 'Long',
			type: 'IN'
		},
		{
			propertyName: 'targetDeviceType',
			text: 'Target Device Type',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	columns: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'project.name',
			text: 'Project',
			textKey: 'project.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'sourceDeviceType.name',
			text: 'Source Device Type',
			textKey: 'sourceDeviceType.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'targetDeviceType.name',
			text: 'Target Device Type',
			textKey: 'targetDeviceType.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
});

function PredictionTypeTable() {
	const user = useSelector(({ auth }) => auth.user);
	return <TableBrowser config={config({ user })} />;
}

export default withReducer('predictionTypeTable', reducer('predictionTypeTable'))(PredictionTypeTable);
